import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DocumentType } from '../enums';
import { DocumentViewerComponent } from '../components/document-viewer/document-viewer.component';
import {
  getDocumentName,
  getDocumentType,
  processDocumentImage,
} from './document-processing.utility';

@Injectable()
export class DocumentUtility {
  constructor(private dialog: MatDialog) {}

  processImage(path: string, url: string): Observable<string[]> {
    return processDocumentImage(path, url);
  }

  getDocumentName(path: string): string {
    return getDocumentName(path);
  }

  getDocumentType(src: string): DocumentType {
    return getDocumentType(src);
  }

  openDocumentDialog(
    data: Partial<{ path: string; url: string; base64: string }>,
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(DocumentViewerComponent, {
      width: '800px',
      maxWidth: '90vw',
      height: '600px',
      maxHeight: '90vh',
      disableClose: true,
      closeOnNavigation: true,
      panelClass: 'ks-document-viewer-dialog-container',
      data: { isDialog: true, ...data },
    });

    return dialogRef.afterClosed();
  }
}
